var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFullIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_768_1969)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33203 6.66927V5.0026C3.33203 4.56058 3.50763 4.13665 3.82019 3.82409C4.13275 3.51153 4.55667 3.33594 4.9987 3.33594H6.66536",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33203 13.3359V15.0026C3.33203 15.4446 3.50763 15.8686 3.82019 16.1811C4.13275 16.4937 4.55667 16.6693 4.9987 16.6693H6.66536",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.332 3.33594H14.9987C15.4407 3.33594 15.8646 3.51153 16.1772 3.82409C16.4898 4.13665 16.6654 4.56058 16.6654 5.0026V6.66927",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.332 16.6693H14.9987C15.4407 16.6693 15.8646 16.4937 16.1772 16.1811C16.4898 15.8686 16.6654 15.4446 16.6654 15.0026V13.3359",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_768_1969"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullIcon);
export default __webpack_public_path__ + "static/media/full-icon.b24946b677bf17988d898983b4df1498.svg";
export { ForwardRef as ReactComponent };